import { rgba } from 'polished';
import styled, { css } from 'styled-components';

export const TextStyled = styled.span`
  position: relative;
  display: block;
  font-size: 14px;
  line-height: 1.3em;
  ${({ maxHeight }) => maxHeight && `max-height: ${maxHeight}px`};

  .svgicon {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 10px;
    left: 10px;
  }

  ${({ typeMsg }) =>
    typeMsg === 'error' &&
    css`
      border-color: ${({ theme }) => theme.colors.red2};
      background-color: ${({ theme }) => rgba(theme.colors.red2, 0.15)};
      color: ${({ theme }) => theme.colors.red2};
    `}

  ${({ typeMsg }) =>
    typeMsg === 'success' &&
    css`
      border-color: ${({ theme }) => theme.colors.green1};
      background-color: ${({ theme }) => rgba(theme.colors.green1, 0.25)};
      color: ${({ theme }) => theme.colors.green2};
    `}

  ${({ typeMsg }) =>
    typeMsg === 'info' &&
    css`
      color: ${({ theme }) => theme.colors.orange1};
      background-color: ${({ theme }) => theme.colors.orange2};
      border-color: ${({ theme }) => theme.colors.orange1};

      .svgicon {
        fill: ${({ theme }) => theme.colors.orange1};
      }
    `}

  ${({ type }) =>
    type === 'text' &&
    `
    margin: -10px auto 20px;
    font-weight: bold;
    text-align: center;
    background-color: transparent;
  `}

  ${({ type, isIcon }) =>
    type === 'block' &&
    `
    text-align: left;
    margin: 0px auto 10px;
    font-weight: 600;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    padding: ${isIcon ? '10px 10px 10px 32px' : '10px'};
  `}
`;
